<template>
    <div class="flat-card">
        <template v-if="title?.length > 0">
            <h6 class="flat-card__title">
                {{ title }}
            </h6>
        </template>
        <slot></slot>
    </div>

</template>

<script>
export default {
    name: 'flatCard',
    props: {
        title: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.flat-card {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    background-color: var(--background-gray);
    border-radius: var(--radius-lg);
    border: 1px solid var(--border-primary);
    padding: var(--spacing-md);
    box-sizing: border-box;
}

.flat-card__title {
    all: unset;
    font-size: var(--text-sm);
    line-height: 1;
    font-weight: 600;
    color: var(--color-primary);
    text-align: left;
}
</style>